import plasma from '@solfacil/plasma-utils';

export default defineNuxtPlugin(({ vueApp }) => {
  if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
    const STORAGE_KEY = 'analytics_initial_referrer';
    const storedReferrer = sessionStorage.getItem(STORAGE_KEY);
    if (!storedReferrer) {
      const currentReferrer = document.referrer || 'direto (sem referrer)';
      sessionStorage.setItem(STORAGE_KEY, currentReferrer);
    }
  }

  const config = useRuntimeConfig().public;
  const router = useRouter();

  vueApp.use(plasma as any, {
    configuration: {
      enableKeycloak: config.ENABLE_KEYCLOAK === 'true',
      hostProduction: config.HOST_PRODUCTION,
      hostStaging: config.HOST_STAGING,
      router,
    },
    connections: {
      graphql: {
        default: {
          dev: {
            // url: 'http://0.0.0.0:4000/api/graphql',
            url: 'https://dev-apigateway.solfacil.com.br/bff-store/api/graphql',
          },
          prod: {
            url: 'https://kong.solfacil.com.br/prd-bff-store/api/graphql',
          },
          stg: {
            url: 'https://stg-apigateway.solfacil.com.br/stg-bff-store/api/graphql',
          },
        },
      },
      rest: {
        ecommerce: {
          dev: {
            url: 'https://dev-apigateway.solfacil.com.br/bff-store/api/graphql',
          },
          prod: {
            url: 'https://kong.solfacil.com.br/prd-bff-store/api/graphql',
          },
          stg: {
            url: 'https://stg-apigateway.solfacil.com.br/stg-bff-store/api/graphql',
          },
        },
        ibge: {
          dev: {
            url: 'https://servicodados.ibge.gov.br/api/v1',
          },
          prod: {
            url: 'https://servicodados.ibge.gov.br/api/v1',
          },
          stg: {
            url: 'https://servicodados.ibge.gov.br/api/v1',
          },
        },
        cepApi: {
          dev: {
            url: 'https://dev-apigateway.solfacil.com.br/cep-api/cep/',
          },
          prod: {
            url: 'https://kong.solfacil.com.br/prd-cep-api/cep/',
          },
          stg: {
            url: 'https://stg-apigateway.solfacil.com.br/stg-cep-api/cep/',
          },
        },
      },
      keycloak: {
        dev: {
          url: 'https://dev-sso.solfacil.com.br',
          realm: 'General',
          client_id: 'ecommerce',
        },
        prod: {
          url: 'https://sso.solfacil.com.br',
          realm: 'General',
          client_id: 'ecommerce',
        },
        stg: {
          url: 'https://stg-sso.solfacil.com.br',
          realm: 'General',
          client_id: 'ecommerce',
        },
      },
    },
  });
});
